"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var SvgNoEnrolled = function SvgNoEnrolled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 225,
    height: 187,
    viewBox: "0 0 225 187",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 5.52A3.52 3.52 0 015.52 2h177.96A3.52 3.52 0 01187 5.52V163H2V5.52z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#EFEFFA",
    d: "M8 31h174v125H8z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M8 74h174v39H8zM8 12.52A3.52 3.52 0 0111.52 9h166.96a3.52 3.52 0 013.52 3.52V31H8V12.52z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 12.52A3.52 3.52 0 0111.52 9h166.96a3.52 3.52 0 013.52 3.52V31H8V12.52z",
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 43,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 43,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 55,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 55,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 49,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 49,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 48,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 48,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 84,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 84,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 96,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 96,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 90,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 90,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 88,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 88,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 93.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 93.5,
    r: 15.5,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 51.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 126,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 126,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 62.5,
    cy: 134.5,
    r: 15.5,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 137,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 84,
    y: 137,
    width: 38,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 131,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 144,
    y: 131,
    width: 22,
    height: 6,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 130,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 130,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "currentColor",
    fillOpacity: 0.2
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 143,
    y: 17,
    width: 28,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 49,
    y: 17,
    width: 43,
    height: 6,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 21,
    y: 15,
    width: 10,
    height: 10,
    rx: 1.76,
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 170.875c0 2.278-1.823 4.125-4.071 4.125h-48.858c-2.248 0-4.071-1.847-4.071-4.125v-13.689c0-6.447 4.218-12.112 10.335-13.883l4.501-1.303a24.533 24.533 0 0013.664 4.123c4.929 0 9.639-1.441 13.664-4.123l4.501 1.303c6.117 1.771 10.335 7.436 10.335 13.883v13.689z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 170.875c0 2.278-1.823 4.125-4.071 4.125h-48.858c-2.248 0-4.071-1.847-4.071-4.125v-13.689c0-6.447 4.218-12.112 10.335-13.883l4.501-1.303a24.533 24.533 0 0013.664 4.123c4.929 0 9.639-1.441 13.664-4.123l4.501 1.303c6.117 1.771 10.335 7.436 10.335 13.883v13.689z",
    fill: "#fff",
    fillOpacity: 0.96
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.5 171h-20.305c-2.311 0-4.246-2.262-4.246-4.524v-7.88c0-4.488 2.577-8.494 7.051-9.727l2.8-.771c3.083 1.737 7.174 3.102 10.994 3.102a21.438 21.438 0 006.348-.956c1.26-2.208 2.923-4.21 4.974-5.963 2.019-1.727 4.107-2.961 5.884-3.821-2.175-3.872-3.308-8.197-3.308-12.71 0-3.395.65-6.692 1.89-9.761-3.825-4.277-9.484-6.989-15.788-6.989-11.494 0-20.845 9.017-20.845 20.1 0 4.559 1.583 8.768 4.246 12.144C129.576 145.295 124 150.87 124 158.9v9.529c0 5.277 4.453 9.571 9.927 9.571h21.903c-.372-1.245-.33-5.705-.33-7z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.5 118c7.456 0 13.5 6.044 13.5 13.5s-6.044 13.5-13.5 13.5-13.5-6.044-13.5-13.5 6.044-13.5 13.5-13.5z",
    fill: "#fff",
    fillOpacity: 0.96
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.756 140.314c3.433-4.465 5.294-9.912 5.294-15.647C214.05 110.492 202.634 99 188.5 99c-14.11 0-25.55 11.468-25.55 25.667 0 5.735 1.861 11.182 5.294 15.647-2.95.847-16.244 5.905-16.244 21.257v13.905c0 6.354 5.146 11.524 11.471 11.524h50.058c6.325 0 11.471-5.17 11.471-11.524v-13.905c0-15.351-13.285-20.408-16.244-21.257z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.5 106c10.217 0 18.5 8.283 18.5 18.5s-8.283 18.5-18.5 18.5-18.5-8.283-18.5-18.5 8.283-18.5 18.5-18.5zM218 174.974c0 2.247-2.558 5.026-4.748 5.026h-48.126c-2.19 0-6.126-3.718-6.126-5.964v-12.217c0-6.357 5.602-12.816 8.162-14.316 2.561-1.5 5.19-2.699 6.287-3.003 4.069 3.352 10.249 5 15.051 5s10.5-2 15.281-5c6.634 1.877 14.219 9.161 14.219 15.518v14.956z",
    fill: "#fff",
    fillOpacity: 0.96
  }));
};
var _default = exports.default = SvgNoEnrolled;